// YERİ: src/app/domains/website/core/mkt-chrome-text.ts
//
// VİTRİN KABUK METİNLERİ — CMS'in sağlamadığı, koda ait birkaç dize.
//
// ── NEDEN TRANSLOCO DEĞİL ──────────────────────────────────────────────────
// Vitrinin dili portal kullanıcısının dili DEĞİL, ziyaretçinin gezdiği
// `/:lang` rotasıdır (LanguageStore). Transloco portal oturumuna bağlı; burada
// kullanılsaydı İngilizce vitrini gezen ziyaretçi, portalı Türkçe kullanan
// birinin tarayıcısında Türkçe kabuk görürdü.
//
// ── NEDEN CMS DEĞİL ────────────────────────────────────────────────────────
// Bunlar içerik değil: ekran okuyucu etiketi, boş medya yer tutucusu, CMS
// etiketi gelmediğinde düşülen yedek. Kiracının düzenlemesi gereken şeyler
// olmadığı için veritabanına konmadı.

import { computed, inject, Injectable, Signal } from '@angular/core';
import { LanguageStore } from './language.store';

type Sozluk = Record<string, string>;

/** Anahtar → dil → metin. Dil yoksa İngilizceye düşer (vitrinin yayın dili). */
const TEXT: Record<string, Sozluk> = {
  menu: {
    en: 'Menu', tr: 'Menü', de: 'Menü', fr: 'Menu', it: 'Menu', es: 'Menú',
    pt: 'Menu', ru: 'Меню', fa: 'منو', ar: 'القائمة',
  },
  effectiveDate: {
    en: 'Effective date', tr: 'Yürürlük tarihi', de: 'Gültig ab',
    fr: "Date d'entrée en vigueur", it: 'Data di efficacia',
    es: 'Fecha de entrada en vigor', pt: 'Data de entrada em vigor',
    ru: 'Дата вступления в силу', fa: 'تاریخ اجرا', ar: 'تاريخ السريان',
  },
  mediaSlot: {
    en: 'Media slot', tr: 'Medya yuvası', de: 'Medienplatz',
    fr: 'Emplacement média', it: 'Spazio media', es: 'Espacio multimedia',
    pt: 'Espaço multimédia', ru: 'Место для медиа', fa: 'جایگاه رسانه',
    ar: 'موضع الوسائط',
  },
};

@Injectable({ providedIn: 'root' })
export class MktChromeText {
  private lang = inject(LanguageStore);

  /**
   * Aktif vitrin dilinde metin.
   * Bilinmeyen dil ya da bilinmeyen anahtar → İngilizce; o da yoksa anahtarın
   * kendisi (sessizce boş dönmek, eksikliği görünmez yapardı).
   */
  t(key: string): string {
    const sozluk = TEXT[key];
    if (!sozluk) return key;
    // `en-ca` gibi bölgeli kodlar da ana dile düşsün.
    const kod = (this.lang.current() || 'en').toLowerCase().split('-')[0];
    return sozluk[kod] ?? sozluk['en'] ?? key;
  }

  /** Şablonda tekrar tekrar çağırmamak için hazır sinyal. */
  sinyal(key: string): Signal<string> {
    return computed(() => this.t(key));
  }
}
